import { Component, Inject, OnInit } from '@angular/core';
import { MD_DIALOG_DATA } from '@angular/material';
import { ProgramArticle } from '../../models/program-article';
import { ProgramArticleService } from '../../services/program-article.service';

@Component({
  selector: 'app-multicams-modal',
  templateUrl: './multicams-modal.component.html',
  styleUrls: ['./multicams-modal.component.scss']
})
export class MulticamsModalComponent implements OnInit {

  spevId: number;
  languageId: number;
  loading: boolean;
  destination: string;
  programArticles: ProgramArticle[];

  constructor(@Inject(MD_DIALOG_DATA) public data: any,
    private programArticleService: ProgramArticleService) {
    this.spevId = data.spevId;
    this.languageId = data.languageId;
    this.destination = data.destination;
  }

  ngOnInit() { this.getMultiCamInfos(); }

  getMultiCamInfos() {
    this.loading = true;
    this.programArticles = [];
    this.programArticleService.getMultiCamInfos(this.spevId, this.languageId).subscribe((programArticles) => {
      programArticles.forEach(program => {
        program.destinations = program.destinations.filter(d => d.id == this.destination);
        if (program.destinations.length > 0) {
          program.destinations[0].value.translations = program.destinations[0].value.translations.filter(t => t.fieldName === "Title");
        }
        this.programArticles.push(program);
      });
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/multicams-modal/multicams-modal.component.ts